function ErrorCard({ error, onRetry }) {
  const is401 = error && (error.includes('401') || error.includes('Unauthorized'));
  return (
    <div style={{
      background: '#FFF1F2', border: '2px solid #BE123C',
      borderRadius: 8, padding: '2rem', textAlign: 'center',
      maxWidth: 480, margin: '2rem auto',
    }}>
      <div style={{ fontSize:'2rem', marginBottom:'0.75rem' }}>
        {is401 ? '🔒' : '🔴'}
      </div>
      <div style={{ fontWeight:700, color:'#BE123C', fontSize:'1rem', marginBottom:'0.5rem' }}>
        {is401 ? 'Authentication Required' : 'Error loading data'}
      </div>
      <div style={{ color:'#64748B', fontSize:'0.85rem', marginBottom:'1.25rem' }}>
        {is401
          ? 'Please refresh the page and enter your Acct4cast credentials.'
          : (error || 'The API returned an error. Check the Express server terminal.')
        }
      </div>
      {onRetry && !is401 && (
        <button onClick={onRetry} className="btn-primary">Retry</button>
      )}
      {is401 && (
        <button onClick={() => window.location.reload()} className="btn-primary">
          Reload Page
        </button>
      )}
    </div>
  );
}

export default ErrorCard;
